import { GenericObject } from "utility/misc";

export default function redirectToAWSConnectPage(
  orgStore: GenericObject,
  navigate: Function
): void {
  navigate("/environment/sources/aws/connect");
}
